import { G, Path, Svg } from 'react-native-svg'

// eslint-disable-next-line no-relative-import-paths/no-relative-import-paths
import { createIcon } from '../factories/createIcon'

export const [ArbiscanLogoLight, AnimatedArbiscanLogoLight] = createIcon({
  name: 'ArbiscanLogoLight',
  getIcon: (props) => (
    <Svg fill="none" viewBox="0 0 20 20" {...props}>
      <G>
        <Path
          d="M2.15698 6.24434V13.7557C2.15698 14.2353 2.41318 14.6787 2.82812 14.9177L9.33043 18.6741C9.7453 18.9131 10.2561 18.9131 10.6711 18.6741L17.1734 14.9177C17.5883 14.6787 17.8445 14.2353 17.8445 13.7557V6.24434C17.8445 5.76475 17.5883 5.32134 17.1734 5.08233L10.6711 1.32588C10.2561 1.08687 9.7453 1.08687 9.33043 1.32588L2.82654 5.08233C2.4116 5.32134 2.15698 5.76475 2.15698 6.24434Z"
          fill="white"
        />
        <Path
          d="M11.4194 11.4568L10.492 14.0009C10.4669 14.0717 10.4669 14.1487 10.492 14.2195L12.0874 18.5971L13.9326 17.531L11.718 11.4568C11.6677 11.3169 11.4696 11.3169 11.4194 11.4568Z"
          fill="black"
        />
        <Path
          d="M13.2786 7.17832C13.2282 7.03838 13.0302 7.03838 12.9799 7.17832L12.0526 9.72243C12.0274 9.79319 12.0274 9.87024 12.0526 9.941L14.6664 17.108L16.5116 16.0419L13.2786 7.17832Z"
          fill="black"
        />
        <Path
          d="M10.0001 1.60733C10.0456 1.60733 10.0913 1.61991 10.1321 1.64192L17.1688 5.70657C17.2505 5.75374 17.3008 5.8418 17.3008 5.93456V14.0623C17.3008 14.1566 17.2505 14.2431 17.1688 14.2903L10.1321 18.355C10.0929 18.3785 10.0456 18.3895 10.0001 18.3895C9.95454 18.3895 9.90891 18.377 9.86807 18.355L2.83138 14.2934C2.74965 14.2462 2.69936 14.1582 2.69936 14.0655V5.93613C2.69936 5.8418 2.74965 5.75531 2.83138 5.70814L9.86807 1.64349C9.90891 1.61991 9.95454 1.60733 10.0001 1.60733ZM10.0001 0.420166C9.75017 0.420166 9.49875 0.484634 9.27396 0.615143L2.23884 4.67822C1.78933 4.93766 1.5127 5.41724 1.5127 5.93613V14.0639C1.5127 14.5828 1.78933 15.0624 2.23884 15.3218L9.27555 19.3864C9.50026 19.5154 9.75017 19.5814 10.0017 19.5814C10.2516 19.5814 10.503 19.517 10.7278 19.3864L17.7645 15.3218C18.214 15.0624 18.4906 14.5828 18.4906 14.0639V5.93613C18.4906 5.41724 18.214 4.93766 17.7645 4.67822L10.7262 0.615143C10.5014 0.484634 10.25 0.420166 10.0001 0.420166Z"
          fill="black"
        />
        <Path
          d="M5.34619 17.1175L5.99375 15.3438L7.29672 16.4271L6.07863 17.5404L5.34619 17.1175Z"
          fill="white"
        />
        <Path
          d="M9.4076 5.35435H7.62365C7.49004 5.35435 7.3706 5.43769 7.32502 5.56348L3.50098 16.0513L5.3462 17.1175L9.55693 5.5682C9.59617 5.46442 9.5192 5.35435 9.4076 5.35435Z"
          fill="black"
        />
        <Path
          d="M12.5292 5.35435H10.7452C10.6116 5.35435 10.4922 5.43769 10.4466 5.56348L6.08032 17.5388L7.92555 18.605L12.6785 5.5682C12.7162 5.46442 12.6392 5.35435 12.5292 5.35435Z"
          fill="black"
        />
      </G>
    </Svg>
  ),
})
